const DEBUG = false;

class AuthLogger {
    private static instance: AuthLogger;
    private readonly prefix = '[Auth]';

    private constructor() {}

    public static getInstance(): AuthLogger {
        if (!AuthLogger.instance) {
            AuthLogger.instance = new AuthLogger();
        }
        return AuthLogger.instance;
    }

    public info(message: string, ...args: any[]): void {
        console.info(`${this.prefix} ${message}`, ...args);
    }

    public debug(message: string, ...args: any[]): void {
        if (DEBUG) {
            console.debug(`${this.prefix} ${message}`, ...args);
        }
    }

    public warn(message: string, ...args: any[]): void {
        console.warn(`${this.prefix} ${message}`, ...args);
    }

    public error(message: string, ...args: any[]): void {
        console.error(`${this.prefix} ${message}`, ...args);
    }

    public tokenRefresh(message: string, expirationMs?: number): void {
        if (expirationMs) {
            const expirationDate = new Date(expirationMs);
            this.info(`Token Refresh: ${message}. Expires: ${expirationDate.toISOString()}`);
            
            if (DEBUG) {
                const timeUntilExpiration = expirationMs - Date.now();
                const minutesUntilExpiration = Math.round(timeUntilExpiration / (1000 * 60));
                this.debug(`Time until expiration: ${minutesUntilExpiration} minutes`);
            }
        } else {
            this.info(`Token Refresh: ${message}`);
        }
    }
}

export const authLogger = AuthLogger.getInstance();